import { EPReportsGetPages } from 'types/Endpoints/Reports';
import { UID, UUID } from 'types/types';

export type UserFeatures = {
  createAsset?: boolean;
};

export interface User {
  email: string;
  /** Until v6.34 2023-07-13, id was reference, afterwards it is the user's uid */
  id: string;
  /** @added v6.34 2023-07-13 */
  reference: string;
  name: string;
  ofa: 'password' | 'passwordless';
  tfa: boolean;
  tfaRequired?: boolean;
  avatar: string;
  timestamp: number;
  features?: UserFeatures;
  isSupport?: boolean;
}

export enum AuthenticationSteps {
  authenticated = 'authenticated',
  password = 'password',
  email = 'email',
  emailvalidate = 'emailvalidate',
  setpassword = 'setpassword',
  tfa = 'tfa',
  tfaSetup = 'tfaSetup',
}

export type UserOrganisation = {
  id: UID;
  uuid: UUID;
  // isMain: boolean;
  features: {
    editassetdetails?: boolean;
    viewassetfields?: boolean;
    editassetfields?: boolean;
    editassetplans?: boolean;
    assessmentqa?: boolean;
    reporting?: boolean;
    // setupfields?: boolean;
    // setupassessments?: boolean;
    // setupcategories?: boolean;
    // setupseverities?: boolean;
    // setuptimescales?: boolean;
    // setupbilling?: boolean;
    // setupfieldgroupchecks?: boolean;
    // api?: boolean;
    // setupengage?: boolean;
    // setupsso?: boolean;
    // supportbilling?: boolean;
  };
  // details: {
  //   name: string;
  //   svgLogo: string | null;
  //   pngLogo: string | null;
  //   address1: string;
  //   address2: string;
  //   city: string;
  //   county: string;
  //   postcode: string;
  //   phone: string;
  // };
};

export type UserOrganisationNew = {
  id: UID;
  address: {
    name: string;
    address1: string;
    address2: string;
    city: string;
    county: string;
    postcode: string;
  };
  svgLogo: string | null;
  pngLogo: string | null;
  userFeatures: {
    fields?: boolean;
    assessments?: boolean;
    categories?: boolean;
    severities?: boolean;
    timescales?: boolean;
    billing?: boolean;
    elementChecks?: boolean;
    api?: boolean;
    engage?: boolean;
    sso?: boolean;
    billingSupport?: boolean;
    complianceSetup?: boolean;
  };
};

export type ApiResponseAuth =
  | {
      step: AuthenticationSteps.email;
      data: {};
    }
  | {
      step: AuthenticationSteps.emailvalidate;
      data: {
        token: string;
        email: string;
        as: boolean | undefined;
      };
    }
  | {
      step: AuthenticationSteps.password;
      data: {
        token: string;
        email: string;
        as: boolean | undefined;
      };
    }
  | {
      step: AuthenticationSteps.tfa;
      data: {
        token: string;
        user: User;
      };
    }
  | {
      step: AuthenticationSteps.tfaSetup;
      data: {
        token: string;
        email: string;
        data: {
          uri: string;
          secret: string;
          required: { date: number } | null;
        };
      };
    }
  | {
      step: AuthenticationSteps.setpassword;
      data: {
        token: string;
        user: User;
      };
    }
  | {
      step: AuthenticationSteps.authenticated;
      data: {
        authToken: string;
        urlToken: string;
        user: User;
        organisation: UserOrganisationNew | null;
        organisations: Record<string, UserOrganisation>;
        pages: EPReportsGetPages['response']['pages'];
        offlineOnly: boolean | undefined;
      };
    };

export interface AuthenticationPayload {
  email?: string;
  id?: string;
  password?: string;
  code?: string;
}

export interface AuthState {
  step: AuthenticationSteps;
  authStepCanAs: boolean | undefined;
  authStepToken: string | undefined;
  authStepEmail: string | undefined;
  authStepAs: string | undefined;
  authStepTfaSetup:
    | {
        secret: string;
        uri: string;
        required: { date: number } | null;
      }
    | undefined;
  promptAuth: boolean;
  error: string | undefined;
  // Persisted
  urlToken: string | undefined;
  user: User | undefined;
  organisations: Record<string, UserOrganisation>;
  organisation: UserOrganisationNew | null;
}

export const defaultOrganisationFeatures: Required<
  UserOrganisation['features']
> = {
  // setupassessments: false,
  // setupbilling: false,
  // setupcategories: false,
  // setupfields: false,
  // setupseverities: false,
  // setuptimescales: false,
  editassetdetails: false,
  editassetfields: false,
  viewassetfields: false,
  editassetplans: true,
  assessmentqa: false,
  // setupfieldgroupchecks: false,
  reporting: false,
  // api: false,
  // setupengage: false,
  // setupsso: false,
  // supportbilling: false,
  // complianceSetup: false,
};

export const defaultSelectedOrganistionUserFeatures: UserOrganisationNew['userFeatures'] =
  {
    api: false,
    assessments: false,
    billing: false,
    billingSupport: false,
    categories: false,
    elementChecks: false,
    engage: false,
    fields: false,
    severities: false,
    sso: false,
    timescales: false,
    complianceSetup: false,
  };
